import React from 'react'
import _ from 'underscore'

class PrintObjectView extends React.Component {
  constructor(params) {
    super(params)
    if (params) {
      this.object = params.object
    }

    this.initialize = this.initialize.bind(this)
    this.renderParams = this.renderParams.bind(this)
    this.parseObject = this.parseObject.bind(this)
    this.render = this.render.bind(this)
  }

  initialize(params) {
    if (params) {
      this.object = params.object
    }
  }

  renderParams() {
    return { object: this.parseObject(this.object) }
  }

  parseObject(object, indent) {
    if (indent === undefined) {
      indent = 0
    }

    return _.map(_.pairs(object), pair => {
      if (_.isObject(pair[1])) {
        return "&nbsp;".repeat(indent) + pair[0] + ":<br/>" + this.parseObject(pair[1], indent + 4)
      } else {
        return "&nbsp;".repeat(indent) + pair[0] + ": " + pair[1]
      }
    }).join("<br/>")
  }

  render() {
    return (
      <div className="m-4"
        dangerouslySetInnerHTML={{__html: this.renderParams().object}} 
      />
    )
  }
}

export default PrintObjectView
